import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBeta } from '../../contexts/BetaContext';
import { useSettings } from '../../contexts/SettingsContext';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const { isBetaMode, basePath } = useBeta();
  const { settings } = useSettings();
  const hasResults = Boolean(settings?.dateEnded);

  // Helper to check if a path is active
  const isActive = (path) => {
    const fullPath = `${basePath}${path}`;
    const normalizedPathname = location.pathname.replace(/\/+$/, '') || '/';
    const normalizedBasePath = (basePath || '').replace(/\/+$/, '') || '/';
    const normalizedFullPath = fullPath.replace(/\/+$/, '') || '/';

    return normalizedPathname === normalizedFullPath ||
      (path === '/leaderboard' && normalizedPathname === normalizedBasePath);
  };

  // V1 simple header - only show on /submit and /past-winners pages
  if (!isBetaMode) {
    const allowedPaths = hasResults
      ? ['/submit', '/past-winners', '/gallery', '/results']
      : ['/submit', '/past-winners', '/gallery'];

    if (!allowedPaths.includes(location.pathname)) {
      return null;
    }

    return (
      <header className="public-header public-header-minimal">
        <div className="header-container">
          <nav className="header-nav header-nav-minimal">
            <Link to="/" className="nav-link">
              Home
            </Link>
            <Link to="/submit" className={`nav-link ${location.pathname === '/submit' ? 'active' : ''}`}>
              Ballot
            </Link>
            {hasResults && (
              <Link to="/results" className={`nav-link ${location.pathname === '/results' ? 'active' : ''}`}>
                Results
              </Link>
            )}
            <Link to="/gallery" className={`nav-link ${location.pathname === '/gallery' ? 'active' : ''}`}>
              Gallery
            </Link>
            <Link to="/past-winners" className={`nav-link ${location.pathname === '/past-winners' ? 'active' : ''}`}>
              Past Winners
            </Link>
          </nav>
        </div>
      </header>
    );
  }

  // Full header for beta mode
  return (
    <header className="public-header">
      <div className="header-container">
        <Link to={`${basePath}/leaderboard`} className="header-logo">
          <span className="logo-text">{settings?.shortPartyName || 'Martin-Resnick Oscar Party'}</span>
        </Link>
        <nav className="header-nav header-nav--split">
          <Link
            to={`${basePath}/leaderboard`}
            className={`nav-link nav-link--left ${isActive('/leaderboard') ? 'active' : ''}`}
          >
            Leaderboard
          </Link>
          <Link
            to={`${basePath}/submit`}
            className={`nav-link nav-link--center ${isActive('/submit') ? 'active' : ''}`}
          >
            Ballot
          </Link>
          <Link
            to={`${basePath}/past-winners`}
            className={`nav-link nav-link--right ${isActive('/past-winners') ? 'active' : ''}`}
          >
            Past Winners
          </Link>
          <Link
            to={`${basePath}/gallery`}
            className={`nav-link ${isActive('/gallery') ? 'active' : ''}`}
          >
            Gallery
          </Link>
        </nav>
        <div className="header-trailing-text">
          <em>You Must Be Present to Win!!</em>
        </div>
      </div>
    </header>
  );
};

export default Header;
